module.exports = __webpack_public_path__ + "static/media/specular_logo_grey.f58a0a72.png";